import {BaseAppEvent} from "../../../infrastructure/models/base-app-event";

export class GoogleAnalyticsEventModel extends BaseAppEvent {
  event;

  constructor(event, addition_params) {
    super();

    this.event = event;
    Object.assign(this, addition_params);
    this.event_source = "365scores";
  }
}
